import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch, RootState, AppDispatch } from '../../redux/store'
import {
  calculateSecurityCheckFamilyActionsCosts,
  getRisksAndIncidentsByExistingControl,
  getSecurityControls,
} from '../../redux/securityCheckFamily/securityCheckFamilyAction'

import {
  Modal,
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Paper,
  TextField,
} from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'
import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone'
import {
  DataGrid,
  GridColDef,
  GridCellParams,
  GridSearchIcon,
} from '@mui/x-data-grid'

import LaunchIcon from '@mui/icons-material/Launch'
import {
  AppBar,
  Button,
  Grid,
  IconButton,
  Toolbar,
  Tooltip,
} from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import DeleteButton from '../../components/common/DeleteButton'
import PaginationComp from '../../components/common/pagination'
import { NavLink, useNavigate, useParams } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import '../../i18n'

import {
  getSecurityNIST,
  getSecurityISO,
  calculateAverageCostForSecurityControl,
} from '../../redux/securityControls/securityControlsAction'
import { Accordion } from '@mui/material'
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from '@mui/material/AccordionSummary'
import MuiAccordionDetails from '@mui/material/AccordionDetails'

import { styled } from '@mui/material/styles'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import SourceTag from '../../components/common/SourceTag'
import GoBackButton from '../../components/common/GoBackButton'
import BreadcrumbsComponent from '../../components/common/GlobalBreadcrumb'
import CardIndicator from '../../components/common/CardIndicator'
import { getRisksAndIncidentsByExistingControlApi } from '../../api/securitycheckfamilysApi'
import MatrixComponent from '../../components/common/MatrixTable'

export default function ExistingControl() {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const { id, securityControlId } = useParams<{
    id: string
    securityControlId: string
  }>()

  const [expanded, setExpanded] = React.useState<{ [panel: string]: boolean }>({
    panel1: true,
    panel2: true,
  })
  const { securityControlData, error } = useSelector(
    (state: RootState) => state.security
  )

  const [page, setPage] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)

  const handlePageSizeChange = (page: number, newSize: number) => {
    setPage(page)
    setPageSize(newSize)
  }

  const dispatch: AppDispatch = useAppDispatch()
  const securityCheckFamilysList = useSelector(
    (state: RootState) => state.securitycheckFamily.SecurityControls
  )

  const loading = useSelector((state: RootState) => state.security.loading)
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(getRisksAndIncidentsByExistingControl(id || ''))
  }, [dispatch, id])

  const { t } = useTranslation()

  const breadcrumbs = [
    { label: t('home'), path: '/' },
    {
      label: t('existingControlsList'),
      path: `/security-existing/${securityControlId}`,
    },
    {
      label: t('existingControl'),
      path: ``,
    },
  ]
  const { RisksAndIncidentsByExistingControl } = useSelector(
    (state: any) => state.securitycheckFamily
  )
  const risks =
    RisksAndIncidentsByExistingControl?.securityControlDetails?.risks || []
  const incidents =
    RisksAndIncidentsByExistingControl?.securityControlDetails?.incidents || []

  const matrixData = []

  if (risks.length > 0) {
    matrixData.push(
      {
        Category: 'Risk',
        Name: risks[0].RisqueName,
        Description: risks[0].Description,
      },
      ...risks.slice(1).map((risk: any) => ({
        Category: '',
        Name: risk.RisqueName,
        Description: risk.Description,
      }))
    )
  } else {
    matrixData.push({
      Category: 'Risk',
      Name: 'No risks available',
      Description: '',
    })
  }

  if (incidents.length > 0) {
    matrixData.push(
      {
        Category: 'Incident',
        Name: incidents[0].IncidentName,
        Description: incidents[0].Description,
      },
      ...incidents.slice(1).map((incident: any) => ({
        Category: '',
        Name: incident.IncidentName,
        Description: incident.Description,
      }))
    )
  } else {
    matrixData.push({
      Category: 'Incident',
      Name: 'No incidents available',
      Description: '',
    })
  }

  const headers = ['Category', 'Name', 'Description']

  return (
    <>
      <div className="page-content">
        <div className="breadcrumbs flex-between-center">
          <div>
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
            <h3 className="title">{t('Existing Control')}</h3>
          </div>
        </div>
        <h4 className="title !ml-0 !mt-[-15px] mb-6">
          Existing Control Analysis
        </h4>
        <h5 className="text-gray-800 font-semibold w-[80%] truncate mt-3">
          Security Control Risks and Incidents Matrix
        </h5>
        <MatrixComponent
          variant="analysis"
          title="Risks and Incidents"
          data={matrixData}
          headers={headers}
        />
      </div>
    </>
  )
}
